export const SEARCH_KEYS = Object.freeze({
  globalSearch: 'gaf-materials-global-search'
});
